import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import './styles/main.css'
import { useTheme } from './composables/useTheme'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)

// Inicializar tema (claro — igual ao app)
const { initTheme } = useTheme()
initTheme()

app.mount('#app')

// Registrar Service Worker para PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('[PWA] Service Worker registrado com sucesso:', registration.scope)

        // Verificar atualizações periodicamente
        setInterval(() => {
          registration.update()
        }, 60000) // Verifica a cada 1 minuto
      })
      .catch((error) => {
        console.log('[PWA] Falha ao registrar Service Worker:', error)
      })
  })
}
